<section
      class="dashboard-grid"
      (dragover)="dragOverGrid($event)"
      (dragleave)="dragLeaveGrid($event)"
      (drop)="dropWidgetAtPointer($event)">
      <div
        class="grid-item"
        *ngFor="let widget of widgets; let index = index; trackBy: trackByWidgetId"
        [attr.data-widget-id]="widget.id"
        [class.is-dragging]="draggedWidgetId === widget.id"
        [style.grid-column]="getGridColumn(widget)"
        [style.grid-row]="getGridRow(widget)">
        <jbm-dashboard-widget
          [widget]="widget"
          [canMoveLeft]="canMoveHorizontally(widget, -1)"
          [canMoveRight]="canMoveHorizontally(widget, 1)"
          [canClose]="canRemoveWidget(widget)"
          (moveLeft)="moveLeft(index)"
          (moveRight)="moveRight(index)"
          (dragStarted)="startDragging($event, widget)"
          (dragEnded)="endDragging()"
          (remove)="removeWidget($event)"
          (changed)="widgetChanged($event)">
        </jbm-dashboard-widget>
      </div>

      <div
        *ngIf="showDropPreview"
        class="drop-preview"
        [style.grid-column]="dropGridColumn"
        [style.grid-row]="dropGridRow">
        Laat hier los
      </div>

</section>
